import { connect } from "react-redux";
import * as taskactions from "../applicationTasks/task.actions";
import * as usersActions from "../../services/users/actions";
import * as applicationActions from "./actions";

function mapStateToProps(state) {
  return {
    applicationsTasks: state.applicationsTasks,
    applications: state.applications.applications,
    accountInfos: state.users.accountInfos,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    initTasks: () => {
      dispatch(taskactions.init_task_applications());
    },

    getApplicationTasks: () => {
      dispatch(taskactions.get_task_applications());
    },

    assignApplicationTasks: (number) => {
      dispatch(taskactions.assign_task_applications(number));
    },

    getOtherUsersTasks: () => {
      dispatch(taskactions.get_allsessions_task_applications());
    },

    dropSingle: (id) => {
      dispatch(taskactions.drop_task_applications(id));
    },

    changeApplicationTaskListPage: (page) => {
      dispatch(taskactions.change_application_list_page(page));
    },

    changeApplicationTaskListFilter: (type, key, value) => {
      dispatch(taskactions.change_application_list_filter(key, value));
    },

    moveToReview: (id) => {
      dispatch(applicationActions.transfer_to_review(id));
    },

    getAccountInfoForId: (accountId) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
    },

    approveApplication: (applicationId, offerId) => {
      dispatch(applicationActions.approve_application(applicationId, offerId));
    },

    rejectApplication: (applicationId) => {
      dispatch(applicationActions.reject_application(applicationId));
    },
  };
}

export const assignedApplicationsConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
